(function () {
    'use strict';

    run.parts.circleProgressBars = function() {
        const globalConfig = {
            "strokeBottom": 5,
            "stroke": 5,
            "colorSlice": "#222",
            "colorCircle": "#f1f1f1",
            "round": true,
            "cut": 30,
            "rotation": 144,
            "fontWeight": 300,
            "size": 130,
        }

        const circle = new CircularProgressBar('__pie', globalConfig);
        circle.initial();
    };
})();